import React, { useRef, useState, useEffect } from "react";
import html2canvas from "html2canvas";
import certificateImage from "../../college/assets/new-award-certifiacate.png";
import signatureImage from "../../college/assets/RajashekarSignature.png";
import moment from "moment";
import "./NewCertificate.scss";

interface CertificateGeneratorProps {
  defaultName?: string;
  defaultSurname?: string;  // Added for displaying surname separately
  defaultContent?: string;
  defaultCategory?: string;
  defaultFinancialAward?: string;
  defaultCertificateId?: string;
  defaultDate?: string;
  certificateImageSrc?: string;
}

const NewCertificateGenerator: React.FC<CertificateGeneratorProps> = ({
  defaultName = "Venkata",
//   defaultSurname = "Machavaram", // Default surname updated to match design
  defaultContent = "For outstanding performance in the <strong> College Mentor Scholarship </strong> Test. Your dedication and excellence have placed you among the top achievers in",
  defaultCategory = "Championing Gender Equality - Boys Category",
  defaultFinancialAward = "Cash Prize Worth Rs. 10000, Partner University Scholarships of Rs. 7500 and College Mentor Services worth Rs. 5000",
  defaultCertificateId = "CMS-1000932025",
  defaultDate = "12/05/2025", // Updated date format to match design
  certificateImageSrc = certificateImage,
}) => {
  const certificateRef = useRef<HTMLDivElement | null>(null);
  const imgRef = useRef<HTMLImageElement | null>(null);
  const [scale, setScale] = useState(1);

  // Update scale factor based on wrapper width
  useEffect(() => {
    const updateScale = () => {
      if (certificateRef.current) {
        const width = certificateRef.current.clientWidth;
        setScale(width / 1280);
      }
    };
    // Initial scale update after image loads
    if (imgRef.current) {
      if (imgRef.current.complete) {
        updateScale();
      } else {
        imgRef.current.addEventListener('load', updateScale);
      }
    }
    window.addEventListener('resize', updateScale);
    return () => {
      window.removeEventListener('resize', updateScale);
      if (imgRef.current) {
        imgRef.current.removeEventListener('load', updateScale);
      }
    };
  }, []);

  // Function to handle social media sharing
  const handleShare = (platform: string) => {
    // This is a placeholder for future implementation
    console.log(`Sharing to ${platform}`);
    // In the future, we could implement actual sharing functionality
  };

  return (
    <div className="new-certificate-wrapper" ref={certificateRef}>
      <img
        src={certificateImageSrc}
        alt="Certificate of Appreciation"
        ref={imgRef}
        className="new-certificate-image"
        width={1280}
        height={960}
      />
      <div
        className="new-certificate-text"
        style={{ '--scale': scale } as React.CSSProperties}
      >
        {/* Name with Great Vibes font */}
        <div className="new-certificate-name">{defaultName}</div>
        
        {/* Surname with Poppins font */}
        {/* <span className="new-certificate-surname">{defaultSurname}</span> */}
        
        {/* Content structured exactly as in the design */}
        <div className="new-certificate-content">
          <span dangerouslySetInnerHTML={{ __html: defaultContent }} /> <strong className="category-name">{defaultCategory}</strong> Recognizing your accomplishments, you have been awarded <strong className="category-name">{defaultFinancialAward}</strong>
        </div>
        
        {/* Signature image */}
        <div className="signature-container">
          {signatureImage && (
            <img src={signatureImage} alt="Signature" className="new-certificate-signature" />
          )}
        
        </div>
        
        {/* Certificate ID and Date with labels - Left side */}
        <div className="certificate-details-left">
          <div className="details-group">
            <span className="new-certificate-id">{defaultCertificateId}</span>
          </div>
        </div>
        
        {/* Certificate ID and Date with labels - Right side */}
        <div className="certificate-details-right">
          <div className="details-group">
            <span className="new-certificate-date">{defaultDate}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewCertificateGenerator;